export default {
  title: 'Kontaktoplysninger',
  form: {
    customer_first_name: {
      placeholder: 'Fornavn',
    },
    customer_last_name: {
      placeholder: 'Efternavn',
    },
    customer_email: {
      placeholder: 'E-mailadresse',
    },
    customer_phone_number: {
      placeholder: 'Telefonnummer',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Indtast dit fornavn',
    },
    customer_last_name: {
      required: 'Indtast dit efternavn',
    },
    customer_email: {
      required: 'Indtast din e-mail',
    },
    customer_phone_number: {
      required: 'Indtast dit telefonnummer',
    },
  },
};
